import { useMemo } from "react";

export const useGetStripeName = (price_id) => {
    return useMemo(() => {
        let planName;
        switch (price_id) {
            case process.env.REACT_APP_STRIPE_BASIC_MONTHLY:
            case process.env.REACT_APP_STRIPE_BASIC_YEARLY:
                planName = 'Basic';
                break;
            case process.env.REACT_APP_STRIPE_PRO_MONTHLY:
            case process.env.REACT_APP_STRIPE_PRO_YEARLY:
                planName = 'Pro';
                break;
            case process.env.REACT_APP_STRIPE_SCALE_MONTHLY:
            case process.env.REACT_APP_STRIPE_SCALE_YEARLY:
                planName = 'Scale';
                break;
            case process.env.REACT_APP_STRIPE_QR_EVERYTHING_MONTHLY:
            case process.env.REACT_APP_STRIPE_QR_EVERYTHING_YEARLY:
                planName =  'QR Everything';
                break;
            case 0:
            default:
                if (price_id && price_id?.startsWith('price')) {
                    planName = 'Custom';
                    break;
                };

                planName = 'Free';
                break;
        };
        return planName;
    },[price_id]);
};
